import { createSlice } from '@reduxjs/toolkit'

type SessionSliceState =
  | {
      accessToken: string
      isAuthorized: true
    }
  | {
      isAuthorized: false
      accessToken?: string
    }

const initialState: SessionSliceState = {
  isAuthorized: false,
}

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    clearSessionData: state => {
      state.accessToken = undefined
      state.isAuthorized = false
    },
  },
  extraReducers: builder => {},
})

export const selectIsAuthorized = (state: RootState) =>
  state.session.isAuthorized

export const selectUserId = (state: RootState) => state.session.userId

export const { clearSessionData } = usersSlice.actions
